import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.light,
    width: "45em",
    height: "33em",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "7%",
  },
  statsLabel: {
    color: theme.palette.primary.main,
    textTransform: "none",
    paddingBottom: theme.spacing(10),
  },
  strong: {
    color: theme.palette.primary.dark,
  },
  timeDescription: {
    color: theme.palette.primary.contrastText,
    fontSize: "72px",
    padding: theme.spacing(3),
  },
  timeGroup: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    paddingBottom: theme.spacing(14),
  },
}));

export default useStyles;
